import ko from 'knockout';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/budgetlandscape');

export default class ViewModel {
  constructor() {
    this.isThumbVisible = ko.observable(true);
    this.isSelected = false;

    this.isLikeVisible = ko.observable(true);
    this.isLikeSolidVisible = ko.observable(false);
    this.isDislikeVisible = ko.observable(true);
    this.isDislikeSolidVisible = ko.observable(false);

    this.isRecommendedPageLinkVisible = ko.observable(false);

    this.feedbackComment = ko.observable(i18n.get('Budget_Landscape_Feedback_IsHelpful'));

    this.overLike = () => {
      if (!this.isSelected)      {
        this.isLikeVisible(false);
        this.isLikeSolidVisible(true);
      }
    };

    this.overLikeOut = () => {
      if (!this.isSelected)      {
        this.isLikeVisible(true);
        this.isLikeSolidVisible(false);
      }
    };

    this.overDislike = () => {
      if (!this.isSelected)      {
        this.isDislikeVisible(false);
        this.isDislikeSolidVisible(true);
      }
    };

    this.overDislikeOut = () => {
      if (!this.isSelected)      {
        this.isDislikeVisible(true);
        this.isDislikeSolidVisible(false);
      }
    };

    this.onClickLike = () => {
      this.isSelected = true;
      this.isThumbVisible(false);
      this.feedbackComment(i18n.get('Budget_Landscape_Feedback_Thanks'));
    };

    this.onClickDislike = () => {
      this.isSelected = true;
      this.isThumbVisible(false);
    };
  }
}
